import { useFiltersContext } from '@openx/components-filters/lib/context/FiltersContext';
import { TopBar } from '@openx/components-table/ChipFilters/TopBar';
import { useTranslation } from 'react-i18next';
import type { CuratedDealBuyerDiscountsListFilters } from './types';

export const CuratedDealBuyerDiscountsTopBar = () => {
  const { onFiltersChange, criteria } = useFiltersContext<CuratedDealBuyerDiscountsListFilters>();
  const { t } = useTranslation();

  return (
    <TopBar
      filters={criteria.filters as CuratedDealBuyerDiscountsListFilters}
      minLength={1}
      onChange={onFiltersChange}
      searchText={t('Search Name, ID or Received Seat ID')}
      useFiltersV2
    />
  );
};
